import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

export const { Types, Creators } = createActions({
    githubApiRequest: [],
    getGithubApi: ['filter'],
    githubApiSuccess: ['data'],
    githubApiError: ['err']
  });
  
  /* Initial State */
  
  export const INITIAL_STATE = Immutable({
    data: [],
    loading: false,
    error: false
  });
  
  /* Reducers */
  
  export const request = state => state.merge({ loading: true });
  
  export const success = (state, { data }) => state.merge({ data, error: false, loading: false });
  
  export const error = state => state.merge({ loading: false, error: true });
  
  /* Reducers to types */
  
  export default createReducer(INITIAL_STATE, {
    [Types.GITHUB_API_REQUEST]: request,
    [Types.GITHUB_API_SUCCESS]: success,
    [Types.GITHUB_API_ERROR]: error
  });